import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-end px-4"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { class: "pb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ColumnCorrespondence = _resolveComponent("ColumnCorrespondence")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    flat: "",
    style: {"max-width":"950px"}
  }, {
    default: _withCtx(() => [
      (_ctx.ofx && _ctx.step > 1 && _ctx.ofxCounter.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h3", null, _toDisplayString(`${_ctx.ofxCounter.current}/${_ctx.ofxCounter.length}`), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === 1 || _ctx.step === 2)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            "no-gutters": "",
            class: "pt-4 d-flex align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "px-6",
                cols: "auto"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("h2", null, "Compte associé", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "auto",
                class: "px-6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    density: "compact",
                    modelValue: _ctx.bankAccount,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bankAccount) = $event)),
                    items: _ctx.bankAccounts,
                    label: "Compte bancaire",
                    "item-title": "name",
                    "item-value": "id",
                    "return-object": "",
                    "hide-details": "",
                    "min-width": "200px"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.emptyMessage !== '' && _ctx.step > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_alert, {
              value: true,
              type: "warning"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.emptyMessage), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.wrongFormat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_alert, {
              value: true,
              type: "error"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Ce fichier n'est pas au bon format. Veuillez choisir un autre fichier.")
              ])),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.foundErrors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_alert, {
              value: true,
              type: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errorDescription), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step) = $event)),
        touchless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, {
            value: 0,
            class: "py-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocuments, {
                companyId: _ctx.selectedCompany && _ctx.selectedCompany.id ? _ctx.selectedCompany.id : null,
                showFirstPrevious: false,
                documentType: 'BANK_STATEMENT',
                inExtensions: _ctx.extensions,
                multiple: false,
                freeTag: false,
                gDrive: false,
                dBox: false,
                onFileInput: _ctx.onFileChanged,
                onFileDeleted: _ctx.onFileDeleted,
                onTestFileInput: _ctx.onTestFileChanged
              }, null, 8, ["companyId", "inExtensions", "onFileInput", "onFileDeleted", "onTestFileInput"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, {
            value: 1,
            style: {"width":"900px"}
          }, {
            default: _withCtx(() => [
              (_ctx.step > 0 && _ctx.existingFile && !_ctx.ofx)
                ? (_openBlock(), _createBlock(_component_ColumnCorrespondence, {
                    key: 0,
                    ref: "columnComponent",
                    result: _ctx.result,
                    extension: _ctx.extension,
                    ignoreHeaders: _ctx.scanBank,
                    actions: _ctx.actions,
                    ruleManager: _ctx.ruleManager,
                    formatColumns: _ctx.formatColumns,
                    requireDateVerification: true,
                    updateAccountingDates: true,
                    validateAccountingDates: true,
                    preProcessFunction: _ctx.processBankTransaction,
                    onColumnsChosen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChosenColumns($event))),
                    onBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 0))
                  }, null, 8, ["result", "extension", "ignoreHeaders", "actions", "ruleManager", "formatColumns", "preProcessFunction"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "default_card large",
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            "two-line": "",
                            style: {"background-color":"transparent"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_virtual_scroll, {
                                "item-height": 75,
                                items: _ctx.importedItems,
                                height: "450",
                                class: "py-3"
                              }, {
                                default: _withCtx(({ item }) => [
                                  _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: item.key,
                                      inactive: "",
                                      class: "oss-list-item"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "1",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_checkbox_btn, {
                                                  color: "primary",
                                                  "onUpdate:modelValue": ($event: any) => (_ctx.select(item)),
                                                  ripple: false,
                                                  "model-value": _ctx.isSelected(item)
                                                }, null, 8, ["onUpdate:modelValue", "model-value"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { cols: "8" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "d-flex align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "12",
                                                      class: "d-flex pb-2 font-weight-bold align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          icon: "$label",
                                                          large: "",
                                                          left: "",
                                                          color: "green"
                                                        }),
                                                        (
                                                                        item.connectPattern &&
                                                                        item.pattern &&
                                                                        item.pattern.rules &&
                                                                        item.pattern.rules
                                                                            .outputWording
                                                                    )
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(_toDisplayString(item.pattern.rules
                                                                            .outputWording), 1)
                                                            ], 64))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _createTextVNode(_toDisplayString(item["wording"].substring(
                                                                            0,
                                                                            100,
                                                                        )), 1)
                                                            ], 64))
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      cols: "3",
                                                      class: "px-1 d-flex align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          icon: "$euro",
                                                          small: "",
                                                          left: "",
                                                          color: "green"
                                                        }),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.getAmount(item)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      cols: "3",
                                                      class: "px-1 d-flex align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: "green",
                                                          size: "small",
                                                          location: "start"
                                                        }, {
                                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                            _createTextVNode("$oss-calendar")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createTextVNode(_toDisplayString(item["date"]), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (_ctx.positions.dateRealization)
                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 0,
                                                          cols: "3",
                                                          class: "px-1 d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                              icon: "$fa-hourglass-half",
                                                              small: "",
                                                              left: "",
                                                              color: "secondary"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(item["dateRealization"]), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_col, {
                                                      cols: "3",
                                                      class: "d-flex px-1 align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (
                                                                        item.pattern &&
                                                                        item.pattern.rules
                                                                            .accountableAccount
                                                                    )
                                                          ? (_openBlock(), _createElementBlock("p", {
                                                              key: 0,
                                                              class: _normalizeClass(
                                                                        item.connectPattern
                                                                            ? ''
                                                                            : 'text-decoration-line-through'
                                                                    )
                                                            }, " Compte Comptable : " + _toDisplayString(item.pattern.rules
                                                                            .accountableAccount.name), 3))
                                                          : _createCommentVNode("", true),
                                                        (
                                                                        item.pattern &&
                                                                        item.pattern.rules
                                                                            .thirdPartyAccountableAccount
                                                                    )
                                                          ? (_openBlock(), _createElementBlock("p", {
                                                              key: 1,
                                                              class: _normalizeClass(
                                                                        item.connectPattern
                                                                            ? ''
                                                                            : 'text-decoration-line-through'
                                                                    )
                                                            }, " Compte de Tiers : " + _toDisplayString(item.pattern.rules
                                                                            .thirdPartyAccountableAccount
                                                                            .name), 3))
                                                          : _createCommentVNode("", true),
                                                        (
                                                                        item.pattern &&
                                                                        item.pattern
                                                                            .thirdPartyCompany &&
                                                                        item.pattern
                                                                            .thirdPartyCompany.name
                                                                    )
                                                          ? (_openBlock(), _createElementBlock("p", {
                                                              key: 2,
                                                              class: _normalizeClass(
                                                                        item.connectPattern
                                                                            ? ''
                                                                            : 'text-decoration-line-through'
                                                                    )
                                                            }, " Société : " + _toDisplayString(item.pattern
                                                                            .thirdPartyCompany.name), 3))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { cols: "1" }, {
                                              default: _withCtx(() => [
                                                (_ctx.invalidDate(item))
                                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                      key: 0,
                                                      location: "end"
                                                    }, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createElementVNode("b", _normalizeProps(_guardReactiveProps(props)), [
                                                          (_ctx.invalidDate(item))
                                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 0,
                                                                icon: "$error",
                                                                color: "error"
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ], 16)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _cache[11] || (_cache[11] = _createElementVNode("span", null, [
                                                          _createTextVNode("La transaction est antérieure à la date"),
                                                          _createElementVNode("br"),
                                                          _createTextVNode("autorisée et ne sera pas importée.")
                                                        ], -1))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            (item.pattern)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "2",
                                                  class: "d-flex align-center justify-end"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _cache[12] || (_cache[12] = _createTextVNode(" Appliquer l'analyse ")),
                                                    _createVNode(_component_v_checkbox, {
                                                      class: "ml-1",
                                                      modelValue: item.connectPattern,
                                                      "onUpdate:modelValue": ($event: any) => ((item.connectPattern) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  ])
                                ]),
                                _: 1
                              }, 8, ["items"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "default_card large",
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            class: "oss-list-item ma-2",
                            active: false,
                            link: false
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "pb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                          _createElementVNode("h2", null, "Ajout de solde bancaire - Optionnel", -1)
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "pb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Opérations bancaires importées (du " + _toDisplayString(_ctx.formatDate(_ctx.minDate)) + " au  ", 1),
                                          _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.maxDate)), 1),
                                          _cache[14] || (_cache[14] = _createTextVNode(") "))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    justify: "space-around"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_oss_date_picker_filled, {
                                            modelValue: _ctx.balanceDate,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.balanceDate) = $event)),
                                            required: true,
                                            hideDetails: true,
                                            textFieldReadOnly: false,
                                            prefixDataCy: "bankTransactionImportCSV-",
                                            showCurrent: _ctx.maxDate
                                          }, null, 8, ["modelValue", "showCurrent"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "pt-2 pb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_oss_text_field_filled, {
                                            label: "Solde relevé",
                                            outlined: "",
                                            density: "compact",
                                            required: true,
                                            "hide-details": true,
                                            "append-inner-icon": "$euro",
                                            "data-cy": "bankTransactionImportCSV-balance",
                                            modelValue: _ctx.balance,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.balance) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.forUploadDialog,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.forUploadDialog) = $event)),
        title: "Forcer la validation",
        onValid: _cache[7] || (_cache[7] = ($event: any) => {
                _ctx.importCSV();
                _ctx.forUploadDialog = false;
            }),
        "valid-loading": _ctx.importLoading,
        "valid-title": "Oui",
        "max-width": "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("Voulez-vous vraiment forcer la validation ?")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "valid-loading"])
    ]),
    _: 1
  }))
}